"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumnRatioFromWidth = exports.clearLocalStorageTableProperties = exports.getTableProperties = exports.getLocalStorageKeyForTable = exports.setColumnWidths = exports.getColumnMinWidth = exports.isHiddenColumn = exports.isAutoResizableColumn = exports.getResizableColumnsByColumns = exports.getVisibleColumns = exports.getTableColumns = exports.getColumnId = exports.initResizableTable = void 0;
function initResizableTable(table) {
    if (!flexTableAttributesFilled(table)) {
        return;
    }
    var tableProperties = getTableProperties(table);
    if (isColumnsUpdated(table, tableProperties.columnRatios)) {
        clearLocalStorageTableProperties(table);
        tableProperties = getTableProperties(table);
    }
    setDataShownAttributesToColumnsByTableProperties(table, tableProperties);
    // Is browser width changed in the background (when other table was open)
    var resized = getTableWidth(table) !== tableProperties.tableWidth;
    if (resized) {
        recalculateTableProperties(table);
    }
    else {
        setColumnWidths(table, tableProperties);
    }
    createResizeHandlers(table);
    table.addEventListener('mousedown', mousedown);
    window.addEventListener('resize', function () { return recalculateTableProperties(table); });
    var startX;
    var currentColumn;
    var currentColumnWidth;
    var nextColumn;
    var nextColumnWidth;
    function mousedown(event) {
        if (event.target instanceof HTMLElement && event.target.classList.contains('resize-handle')) {
            startX = event.clientX;
            var targetColumn = event.target.parentElement;
            // Set current resizable column
            if (targetColumn instanceof HTMLTableCellElement) {
                currentColumn = targetColumn;
            }
            while (isUnfitResizeCurrentColumn(table, currentColumn)) {
                if (currentColumn.previousElementSibling instanceof HTMLTableCellElement) {
                    currentColumn = currentColumn.previousElementSibling;
                }
            }
            currentColumnWidth = currentColumn.clientWidth;
            // Set next resizable column
            if (currentColumn.nextElementSibling instanceof HTMLTableCellElement) {
                nextColumn = currentColumn.nextElementSibling;
            }
            while (isUnfitResizeNextColumn(table, nextColumn)) {
                if (nextColumn.nextElementSibling instanceof HTMLTableCellElement) {
                    nextColumn = nextColumn.nextElementSibling;
                }
            }
            nextColumnWidth = nextColumn.clientWidth;
            document.addEventListener('mousemove', mousemove);
            document.addEventListener('mouseup', mouseup, { once: true });
        }
    }
    function mousemove(event) {
        var deltaX = event.clientX - startX;
        var newCurrentColumnWidth = currentColumnWidth + deltaX;
        var newNextColumnWidth = nextColumnWidth - deltaX;
        var isCorrectNewCurrentColumnWidth = newCurrentColumnWidth > getColumnMinWidth(currentColumn);
        var isCorrectNewNextColumnWidth = newNextColumnWidth > getColumnMinWidth(nextColumn);
        var isBothManualResizableColumns = isManualResizableColumn(currentColumn) && isManualResizableColumn(nextColumn);
        if (isCorrectNewCurrentColumnWidth && isCorrectNewNextColumnWidth && isBothManualResizableColumns) {
            requestAnimationFrame(function () {
                currentColumn.style.width = newCurrentColumnWidth + 'px';
                nextColumn.style.width = newNextColumnWidth + 'px';
            });
        }
    }
    function mouseup() {
        calculateTablePropertiesFromCurrentWidths(table);
        document.removeEventListener('mousemove', mousemove);
    }
}
exports.initResizableTable = initResizableTable;
function flexTableAttributesFilled(table) {
    var _a;
    var hasError = false;
    if (!table.dataset.tableId) {
        console.warn('The table must contain a filled "data-table-id" attribute.');
        hasError = true;
    }
    var columns = getTableColumns(table);
    for (var _i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
        var column = columns_1[_i];
        if (!column.dataset.columnId) {
            console.warn('The column must contain a filled "data-column-id" attribute.', column);
            hasError = true;
        }
    }
    var autoResizableVisibleDefaultColumn = (_a = columns
        .find(function (column) { return isAutoResizableColumn(column) && !isHiddenDefaultColumn(column); })) !== null && _a !== void 0 ? _a : null;
    if (autoResizableVisibleDefaultColumn === null) {
        console.warn("The table must contain at least one auto resizable and not hidden by default column.");
        hasError = true;
    }
    return !hasError;
}
function setDataShownAttributesToColumnsByTableProperties(table, tableProperties) {
    var columns = getTableColumns(table);
    for (var _i = 0, columns_2 = columns; _i < columns_2.length; _i++) {
        var column = columns_2[_i];
        var isHidden = tableProperties.columnRatios[getColumnId(column)] === 0;
        column.setAttribute("data-shown", (!isHidden).toString());
    }
}
// Table resizing when changing the browser width
function recalculateTableProperties(table) {
    var tableProperties = getRecalculatedTableProperties(table);
    setColumnWidths(table, tableProperties);
}
function isUnfitResizeCurrentColumn(table, column) {
    var isManualResizable = isManualResizableColumn(column);
    var isHidden = isHiddenColumn(column);
    var columns = getVisibleColumns(table);
    var isFirst = column === columns[0];
    return (!isManualResizable || isHidden) && !isFirst;
}
function isUnfitResizeNextColumn(table, column) {
    var isManualResizable = isManualResizableColumn(column);
    var isHidden = isHiddenColumn(column);
    var columns = getVisibleColumns(table);
    var isLast = column === columns[columns.length - 1];
    return (!isManualResizable || isHidden) && !isLast;
}
function calculateTablePropertiesFromCurrentWidths(table, isInitial) {
    if (isInitial === void 0) { isInitial = false; }
    var columnRatios = {};
    var tableWidth = getTableWidth(table);
    for (var _i = 0, _a = getTableColumns(table); _i < _a.length; _i++) {
        var column = _a[_i];
        var currentColumnWidth = column.clientWidth;
        var isHiddenColumn_1 = isInitial && isHiddenDefaultColumn(column) || !isInitial && currentColumnWidth === 0;
        var minColumnWidth = getColumnMinWidth(column);
        var newColumnWidth = isHiddenColumn_1 ? 0 : Math.max(currentColumnWidth, minColumnWidth);
        columnRatios[getColumnId(column)] = getColumnRatioFromWidth(newColumnWidth, tableWidth);
    }
    saveTableProperties(table, { columnRatios: columnRatios, tableWidth: tableWidth });
    if (isInitial && getHiddenDefaultColumns(table).length > 0) {
        recalculateTableProperties(table);
    }
}
function getColumnId(column) {
    return column.dataset.columnId;
}
exports.getColumnId = getColumnId;
function getTableColumns(table) {
    var firstRow = table.querySelector('tr');
    var headers = firstRow.querySelectorAll('th');
    var cells = firstRow.querySelectorAll('td');
    return Array.from(headers.length ? headers : cells);
}
exports.getTableColumns = getTableColumns;
function getHiddenDefaultColumns(table) {
    return getTableColumns(table).filter(function (column) { return isHiddenDefaultColumn(column); });
}
function getVisibleColumns(table) {
    return getTableColumns(table).filter(function (column) { return getComputedStyle(column).display !== 'none'; });
}
exports.getVisibleColumns = getVisibleColumns;
function getTableWidth(table) {
    return Math.max(table.parentElement.clientWidth, getMinTableWidth(table));
}
// Get current minimal table width (sum of the fixed column widths
// and resizable column minimal widths)
function getMinTableWidth(table) {
    var visibleColumns = getTableColumns(table)
        .filter(function (column) { return !isHiddenColumn(column); });
    var fixedColumns = getFixedColumnsByColumns(visibleColumns);
    var fixedColumnWidthsSum = getColumnWidthsSum(fixedColumns);
    var resizableColumns = getResizableColumnsByColumns(visibleColumns);
    var resizableColumnMinWidthsSum = getColumnMinWidthsSum(resizableColumns);
    return fixedColumnWidthsSum + resizableColumnMinWidthsSum;
}
function getFixedColumnsByColumns(columns) {
    return columns.filter(function (column) { return !isAutoResizableColumn(column); });
}
function getResizableColumnsByColumns(columns) {
    return columns.filter(function (column) { return isAutoResizableColumn(column); });
}
exports.getResizableColumnsByColumns = getResizableColumnsByColumns;
function getColumnWidthsSum(columns) {
    return columns.reduce(function (acc, column) { return acc + column.clientWidth; }, 0);
}
function getColumnMinWidthsSum(columns) {
    return columns.reduce(function (acc, column) { return acc + getColumnMinWidth(column); }, 0);
}
function getColumnRatiosSum(columns, columnRatios) {
    return columns.reduce(function (acc, column) { return acc + columnRatios[getColumnId(column)]; }, 0);
}
function isManualResizableColumn(column) {
    return column.dataset.manualResizable !== 'false';
}
function isAutoResizableColumn(column) {
    return column.dataset.autoResizable !== 'false';
}
exports.isAutoResizableColumn = isAutoResizableColumn;
// Is hidden at the moment
function isHiddenColumn(column) {
    return column.dataset.shown === 'false';
}
exports.isHiddenColumn = isHiddenColumn;
function isHiddenDefaultColumn(column) {
    return column.hasAttribute("data-hidden");
}
// Get recalculated ratios depending on the type of column (fixed or resizable) when the browser width is changing
function getRecalculatedTableProperties(table) {
    var columns = getVisibleColumns(table);
    var newTableWidth = getTableWidth(table);
    var tableProperties = getTableProperties(table);
    var columnRatios = tableProperties.columnRatios;
    var visibleResizableColumns = getResizableColumnsByColumns(columns)
        .filter(function (column) { return columnRatios[getColumnId(column)] !== 0; });
    var resizableColumnRatiosSum = getColumnRatiosSum(visibleResizableColumns, columnRatios);
    var visibleFixedColumns = getFixedColumnsByColumns(columns)
        .filter(function (column) { return columnRatios[getColumnId(column)] !== 0; });
    var newFixedColumnRatiosSum = 0;
    var oldTableWidth = tableProperties.tableWidth;
    tableProperties.tableWidth = newTableWidth;
    for (var _i = 0, visibleFixedColumns_1 = visibleFixedColumns; _i < visibleFixedColumns_1.length; _i++) {
        var column = visibleFixedColumns_1[_i];
        var columnId = getColumnId(column);
        columnRatios[columnId] = roundTo(columnRatios[columnId] * oldTableWidth / newTableWidth, 10);
        newFixedColumnRatiosSum = newFixedColumnRatiosSum + columnRatios[columnId];
    }
    var newResizableColumnRatiosSum = 100 - newFixedColumnRatiosSum;
    for (var _a = 0, visibleResizableColumns_1 = visibleResizableColumns; _a < visibleResizableColumns_1.length; _a++) {
        var column = visibleResizableColumns_1[_a];
        var columnId = getColumnId(column);
        var columnMinWidth = getColumnMinWidth(column);
        if (column.clientWidth > columnMinWidth) {
            columnRatios[columnId] = roundTo(columnRatios[columnId] * newResizableColumnRatiosSum / resizableColumnRatiosSum, 10);
        }
        else {
            columnRatios[columnId] = roundTo(columnMinWidth / newTableWidth * 100, 10);
        }
    }
    tableProperties.columnRatios = columnRatios;
    return tableProperties;
}
function getColumnMinWidth(column) {
    var DEFAULT_COLUMN_MIN_WIDTH = 16; //px
    var columnDataMinWidth = column.dataset.minWidth;
    return columnDataMinWidth ? parseFloat(columnDataMinWidth) : DEFAULT_COLUMN_MIN_WIDTH;
}
exports.getColumnMinWidth = getColumnMinWidth;
function setColumnWidths(table, tableProperties) {
    var tableWidth = getTableWidth(table);
    var columnRatios = tableProperties.columnRatios;
    var _loop_1 = function (column) {
        var columnWidth = getColumnWidthFromRatio(columnRatios[getColumnId(column)], tableWidth);
        requestAnimationFrame(function () { column.style.width = "".concat(columnWidth, "px"); });
    };
    for (var _i = 0, _a = getTableColumns(table); _i < _a.length; _i++) {
        var column = _a[_i];
        _loop_1(column);
    }
    saveTableProperties(table, tableProperties);
}
exports.setColumnWidths = setColumnWidths;
function createResizeHandlers(table) {
    var columns = getTableColumns(table);
    columns.forEach(function (column, index) {
        var isNotLast = index < columns.length - 1;
        if (isNotLast) {
            appendResizeHandle(column);
        }
    });
}
function appendResizeHandle(column) {
    var resizeHandle = document.createElement('span');
    resizeHandle.classList.add('resize-handle');
    column.appendChild(resizeHandle);
}
function getLocalStorageKeyForTable(table) {
    var pathnameId = window.location.pathname.replace(/\d/g, '');
    return "tableProperties-".concat(table.dataset.tableId, "-").concat(pathnameId);
}
exports.getLocalStorageKeyForTable = getLocalStorageKeyForTable;
function getTableProperties(table) {
    var localStorageKey = getLocalStorageKeyForTable(table);
    var savedTablePropertiesJSON = localStorage.getItem(localStorageKey);
    if (savedTablePropertiesJSON === null) {
        calculateTablePropertiesFromCurrentWidths(table, true);
        savedTablePropertiesJSON = localStorage.getItem(localStorageKey);
    }
    var columnRatios = JSON.parse(savedTablePropertiesJSON).columnRatios;
    var tableWidth = parseFloat(JSON.parse(savedTablePropertiesJSON).tableWidth);
    return { columnRatios: columnRatios, tableWidth: tableWidth };
}
exports.getTableProperties = getTableProperties;
function clearLocalStorageTableProperties(table) {
    var LSKey = getLocalStorageKeyForTable(table);
    localStorage.removeItem(LSKey);
}
exports.clearLocalStorageTableProperties = clearLocalStorageTableProperties;
function isColumnsUpdated(table, columnRatios) {
    var columns = getTableColumns(table);
    if (columns.length !== Object.keys(columnRatios).length) {
        return true;
    }
    for (var _i = 0, columns_3 = columns; _i < columns_3.length; _i++) {
        var column = columns_3[_i];
        if (!Object.keys(columnRatios).includes(getColumnId(column))) {
            return true;
        }
    }
    return false;
}
function saveTableProperties(table, tableProperties) {
    var localStorageKey = getLocalStorageKeyForTable(table);
    localStorage.setItem(localStorageKey, JSON.stringify(tableProperties));
}
function getColumnWidthFromRatio(columnRatio, tableWidth) {
    return roundTo(columnRatio * tableWidth / 100, 10);
}
function getColumnRatioFromWidth(columnWidth, tableWidth) {
    return roundTo(columnWidth / tableWidth * 100, 10);
}
exports.getColumnRatioFromWidth = getColumnRatioFromWidth;
function roundTo(number, precision) {
    return parseFloat(number.toFixed(precision));
}
//# sourceMappingURL=resizable-columns.js.map